import uniqueId from "lodash/uniqueId";
import React from "react";
import { Link } from "react-router-dom";
import { utcToLocal } from "util/time.js";

function _renderCheckbox(list, id) {
  if (list.length <= 10) {
    return null;
  }

  return (
    <input
      type="checkbox"
      className="read-more-state"
      id={"read-more-checkbox-" + id}
    />
  );
}

function _renderLabel(list, id) {
  if (list.length <= 10) {
    return null;
  }

  return (
    <label
      htmlFor={"read-more-checkbox-" + id}
      className="read-more-trigger"
    ></label>
  );
}

function formatTargets(targets) {
  let tags = [];
  let devices = [];
  const targetsId = uniqueId("targets-");

  targets.forEach(function (target) {
    switch (target.type) {
      case "t":
        tags.push(target);
        break;
      case "d":
        devices.push(target);
        break;
      default:
        break;
    }
  });

  let lis = [];
  for (let [idx, tag] of Object.entries(tags)) {
    lis.push(
      <li key={`t-${idx}`}>
        <Link to={`/tags/${tag.id}`}>{tag.name}</Link>
      </li>,
    );
  }

  for (let [idx, device] of Object.entries(devices)) {
    lis.push(
      <li key={`d-${idx}`}>
        <Link to={`/devices/${device.id}`}>{device.name}</Link>
      </li>,
    );
  }

  return (
    <div>
      {_renderCheckbox(lis, targetsId)}
      <ul className="read-more-wrap list-unstyled">
        {lis.slice(0, 10)}
        <div className="read-more-target">{lis.slice(10)}</div>
      </ul>
      {_renderLabel(lis, targetsId)}
    </div>
  );
}

function getPriorityLevel(index) {
  const priorityMap = {
    0: {
      text: "Main",
      class: "box-level bg-green",
    },
    1: {
      text: "Fallback",
      class: "box-level bg-yellow",
    },
  };

  const priorityLevel = priorityMap[index];
  if (!priorityLevel) {
    return {
      text: `P${index}`,
      class: "box-level",
    };
  }

  return priorityLevel;
}

function formatDeployDate(date) {
  return utcToLocal(date);
}

function formatStrategy(name, row) {
  return <Link to={`/strategies/${row.strategy_id}`}>{name}</Link>;
}

module.exports = {
  formatDeployDate,
  formatStrategy,
  formatTargets,
  getPriorityLevel,
};
